import { render, staticRenderFns } from "./OrderAttended.vue?vue&type=template&id=024a8b62&"
import script from "./OrderAttended.vue?vue&type=script&lang=js&"
export * from "./OrderAttended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports